var map = {
	"./Bandia/20240504_091008.jpg": 6347,
	"./Bandia/20240504_091024.jpg": 2265,
	"./Bandia/20240504_095709.jpg": 9993,
	"./Casamance/20260205_103759.jpg": 3129,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.21 (1).jpeg": 7746,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.21 (2).jpeg": 541,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.21 (3).jpeg": 2512,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.21.jpeg": 6184,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.22 (1).jpeg": 3711,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.22.jpeg": 4745,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.23 (1).jpeg": 3260,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.23 (2).jpeg": 3131,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.23.jpeg": 9522,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.24 (1).jpeg": 665,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.24 (2).jpeg": 4254,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.24.jpeg": 5379,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.25 (1).jpeg": 2454,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.25 (2).jpeg": 7537,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.25 (3).jpeg": 3732,
	"./Casamance/WhatsApp Image 2026-03-05 at 13.22.25.jpeg": 3724,
	"./Casamance/WhatsApp Video 2026-03-05 at 13.22.24.mp4": 7405,
	"./Dakar city/20240527_090252.jpg": 7889,
	"./Gambia/20240601_183051.jpg": 4063,
	"./Gambia/20250111_114849.jpg": 1291,
	"./Gambia/20250111_114855.jpg": 7428,
	"./Gambia/20251227_151614.jpg": 7089,
	"./Gambia/20251227_151727.jpg": 7910,
	"./Gambia/20251227_151756.jpg": 8534,
	"./Gambia/gambia.jpg": 570,
	"./Goree/goree.jpg": 1398,
	"./Lac Rose/lacrose.jpg": 3790,
	"./Lompoul/Screenshot_20250623-224731_Photos.jpg": 4301,
	"./Lompoul/Screenshot_20250623-224808_Photos.jpg": 724,
	"./Pays Bassari/Screenshot_20251003-094633_Google.jpg": 7818,
	"./Pays Bassari/Screenshot_20251003-094655_Google.jpg": 4926,
	"./Saint Louis/WhatsApp Video 2026-03-06 at 18.04.23.mp4": 2217,
	"./Saint Louis/saintlouis.jpg": 7100,
	"./Sine Saloum/Screenshot_20240917-072830_WhatsApp.jpg": 5586,
	"./Sine Saloum/Screenshot_20240917-072947_WhatsApp.jpg": 6707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 966;